import { t } from '@lingui/macro';

import { Page, PageActions, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { StatusFilter, TimeRangeFilter } from '../../filters';
import ImpactedBusinessServicesPanel from '../../panels/impacted-business-services-panel/ImpactedBusinessServicesPanel';

export const pageId = 'problem-business-services';
export const pageTitle = t`Impacted Business Services`;

export default function ImpactedBusinessServicesPage() {
    return (
        <Page id={pageId}>
            <PageHeader
                title={pageTitle}
                actions={
                    <PageActions pageId={pageId} pageTitle={pageTitle} reportActionOptions={{ canSchedule: false }} />
                }
            >
                <FilterContainer showSavedFilters={false}>
                    <TimeRangeFilter required />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <ImpactedBusinessServicesPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
